// A durable queue job (shift-engine §4; dispatch-plan "jobs").
//
// The queue lives in Postgres so a job is enqueued in the SAME transaction that creates
// its fix (no dual-write, a clean rollback). Every job carries an `idempotencyKey` so a
// retried or duplicate-delivered job does not double-apply. Exhausted retries move to
// `dead_letter`, which raises an Escalated fix. Redis holds rate limits and TTLs but
// never the only copy of a job. Tenant-scoped by `accountId`.
import { z } from "zod";
import { AccountId, FixId, JobId } from "../ids.js";
import { JsonObject, NonEmptyString, Timestamp } from "./common.js";
import { JobState } from "./enums.js";
export const Job = z.object({
    id: JobId,
    accountId: AccountId,
    /** The fix this job advances; null for a platform job not bound to a fix. */
    fixId: FixId.nullable(),
    /** The job kind (a worker selector). A validated string, not a closed set - the queue is generic. */
    kind: NonEmptyString,
    /** Dedupe key: a retried or duplicate job with the same key does not double-apply. */
    idempotencyKey: NonEmptyString,
    state: JobState,
    /** Attempts made so far; compared against `maxAttempts` to decide retry vs dead-letter. */
    attempts: z.int().nonnegative(),
    maxAttempts: z.int().positive(),
    /** When the job becomes claimable (advances on each backoff). */
    availableAt: Timestamp,
    /** The job's input (jsonb). */
    payload: JsonObject,
    /** The last failure reason (no PII), null until a failure occurs. */
    lastError: NonEmptyString.nullable(),
    createdAt: Timestamp,
    updatedAt: Timestamp,
});
//# sourceMappingURL=job.js.map